/** */
import React from 'react';
import { SectionCard } from 'app/shared/section-card';
import { DOMAIN_LABEL } from '../domain-card/config';
import styles from './recommendations.module.css';

const IMPACT_CLASS = { high: 'impactHigh', medium: 'impactMed', low: 'impactLow' };
const EFFORT_CLASS = { high: 'effortHigh', medium: 'effortMed', low: 'effortLow' };

export const Recommendations = ({ recommendations = [], loading }) => {
  if (loading || recommendations.length === 0) return null;

  return (
    <SectionCard
      title="Recommendations"
      action={<span className={styles.count}>{recommendations.length}</span>}
    >
      <div className={styles.cards}>
        {recommendations.map((r, i) => (
          <div key={i} className={styles.card}>
            <div className={styles.cardTop}>
              <span className={styles.domain}>{DOMAIN_LABEL[r.domain] || r.domain}</span>
              <div className={styles.badges}>
                <span
                  className={`${styles.badge} ${styles[IMPACT_CLASS[r.impact] || 'impactMed']}`}
                >
                  {r.impact} impact
                </span>
                <span
                  className={`${styles.badge} ${styles[EFFORT_CLASS[r.effort] || 'effortMed']}`}
                >
                  {r.effort} effort
                </span>
              </div>
            </div>
            <div className={styles.action}>{r.action}</div>
          </div>
        ))}
      </div>
    </SectionCard>
  );
};
